export default {
  'menu.welcome': 'Bienvenue',
  'menu.more-blocks': 'Plus de Blocs',
  'menu.home': 'Accueil',
  'menu.console': 'Admin',
  'menu.console.sub-page': 'Sous-Page',
  'menu.login': 'Connexion',
  'menu.register': 'S\'inscrire',
  'menu.register-result': 'Résultat d\'Inscription',
  'menu.dashboard': 'Tableau de Bord',
  'menu.dashboard.analysis': 'Analyse',
  'menu.dashboard.monitor': 'Surveillance',
  'menu.dashboard.workplace': 'Lieu de Travail',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': 'Formulaire',
  'menu.form.basic-form': 'Formulaire de Base',
  'menu.form.step-form': 'Formulaire par Étapes',
  'menu.form.step-form.info': 'Formulaire par Étapes (saisir les informations de transfert)',
  'menu.form.step-form.confirm': 'Formulaire par Étapes (confirmer les informations de transfert)',
  'menu.form.step-form.result': 'Formulaire par Étapes (terminé)',
  'menu.form.advanced-form': 'Formulaire Avancé',
  'menu.list': 'Liste',
  'menu.list.table-list': 'Table de Recherche',
  'menu.list.basic-list': 'Liste de Base',
  'menu.list.card-list': 'Liste de Cartes',
  'menu.list.search-list': 'Liste de Recherche',
  'menu.list.search-list.articles': 'Liste de Recherche (articles)',
  'menu.list.search-list.projects': 'Liste de Recherche (projets)',
  'menu.list.search-list.applications': 'Liste de Recherche (applications)',
  'menu.profile': 'Profil',
  'menu.profile.basic': 'Profil de Base',
  'menu.profile.advanced': 'Profil Avancé',
  'menu.result': 'Résultat',
  'menu.result.success': 'Succès',
  'menu.result.fail': 'Échec',
  'menu.exception': 'Exception',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'Déclencher',
  'menu.account': 'Compte',
  'menu.account.center': 'Centre de Compte',
  'menu.account.settings': 'Paramètres du Compte',
  'menu.account.trigger': 'Déclencher une Erreur',
  'menu.account.logout': 'Déconnexion',
  'menu.account.profile': 'Profil',
  'menu.console.agents': 'agents',
  'menu.console.agentDevice': 'Appareil Agent',
  'menu.console.devices': 'appareils',
  'menu.console.speakers': 'Reconnaissance de locuteur',
  'menu.console.voiceClone': 'Clonage vocal',
  'menu.console.settings': 'Paramètres personnels',
  'menu.admin': 'Admin',
  'menu.admin.dashboard': 'Tableau de Bord',
  'menu.admin.settings': 'Paramètres',
  'menu.admin.providers': 'Fournisseurs de Modèles',
  'menu.admin.unbindDevice': 'Délier l\'Appareil',
  'menu.admin.userManage': 'Gestion des Utilisateurs',
  'menu.admin.systemConfig': 'Configuration Système',
  'menu.admin.whiteList': 'Liste Blanche',
  'menu.admin.opsManage': 'Opérations',
  'menu.admin.recorderManage': 'Gestion d\'Enregistreur',
  'menu.admin.deviceManage': 'Gestion des appareils',

  'menu.console.agentSetting': 'Paramètres Agent',
};
